import { render, staticRenderFns } from "./CadCorredor.vue?vue&type=template&id=56ec0a06&"
import script from "./CadCorredor.vue?vue&type=script&lang=js&"
export * from "./CadCorredor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports